import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change, but skips scroll if this is a language switch.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (sessionStorage.getItem("xq_lang_switch") === "1") {
      sessionStorage.removeItem("xq_lang_switch");
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
